module.exports = __webpack_public_path__ + "static/work22-d66d1b11e0e36a254605b3bcd52d4ab6.jpg";